import type { PostalCodeValidator } from "../types";
import { successResult } from "../utils";

export const validateIE: PostalCodeValidator = (args) => {
    const { postalCode, isBillingForm, headers } = args;
    if (isBillingForm) return Promise.resolve(successResult());

    const normalizedPostalCode = postalCode?.toUpperCase().replace(/\s+/g, "") ?? "";
    if (!normalizedPostalCode) return Promise.resolve(successResult());

    const blacklistedPrefixes = [
        "BT",
        "IM1",
        "IM2",
        "IM3",
        "IM4",
        "IM5",
        "IM6",
        "IM7",
        "IM8",
        "IM9",
        "TR21",
        "TR22",
        "TR23",
        "TR24",
        "TR25",
        "ZE1",
        "ZE2",
        "ZE3",
        "JE1",
        "JE2",
        "JE3",
        "JE4",
        "JE5",
        "GY1",
        "GY2",
        "GY3",
        "GY4",
        "GY5",
        "GY6",
        "GY7",
        "GY8",
        "GY9",
        "GY10",
        "HS1",
        "HS2",
        "HS3",
        "HS4",
        "HS5",
        "HS6",
        "HS7",
        "HS8",
        "HS9",
        "HS10",
        "SE41AN",
    ];

    if (blacklistedPrefixes.some((prefix) => normalizedPostalCode.startsWith(prefix))) {
        return Promise.resolve({
            isValid: false,
            message: headers?.errors?.undeliverableAddress ?? "",
            key: "undeliverableAddress",
        });
    }
    return Promise.resolve(successResult());
};
